import { getNightCount, getTodayInDefaultTimeZone } from '@utils/helpers'
import { formatIsoDate } from '@utils/utils-format'

type PeriodDate = Date | null | undefined

// GTM keeps a dataLayer key until a later push sets it, so missing dates are pushed as undefined.
export function bookingPeriodDates(from: PeriodDate, to: PeriodDate) {
  return {
    booking_period: from && to ? `from ${formatIsoDate(from)} to ${formatIsoDate(to)}` : undefined,
    booking_period_from: from ? formatIsoDate(from) : undefined,
    booking_period_to: to ? formatIsoDate(to) : undefined,
  }
}

// Berlin calendar days: lead time 0 = today, length = nights for accommodations.
export function bookingPeriodDays(from: PeriodDate, to: PeriodDate) {
  return {
    time_to_period: from ? getNightCount(getTodayInDefaultTimeZone(), from) : undefined,
    period_length_days: from && to ? getNightCount(from, to) : undefined,
  }
}
